import { collection, doc, serverTimestamp, setDoc } from "firebase/firestore";

import { EMAIL_ID } from "../../constants/Email";
import {
  NOTIFICATION_ID,
  NotificationMetaData,
} from "../../constants/Notification";
import { db } from "../firebase";

// Type guard to check if a value is an EMAIL_ID
const isEmailId = (value: any): value is EMAIL_ID => {
  return Object.values(EMAIL_ID).includes(value);
};

const sendNotificationRequest = async (
  userId: string,
  notificationId: NOTIFICATION_ID,
  metaData?: NotificationMetaData
) => {
  const notifDoc = doc(collection(db, "notification_request"));
  await setDoc(notifDoc, {
    createdAt: serverTimestamp(),
    userId,
    notificationId,
    requestId: notifDoc.id,
    meta_data: metaData || [],
  });

  if (isEmailId(notificationId)) {
    const emailDoc = doc(collection(db, "email_requests"));
    await setDoc(emailDoc, {
      createdAt: serverTimestamp(),
      to: userId,
      template_id: notificationId,
      meta_data: metaData || [],
    });
  }
};

const sendNotificationRequests = async (
  userId: string,
  notificationIds: NOTIFICATION_ID[],
  metaData?: NotificationMetaData
) => {
  await Promise.all(
    notificationIds.map(async (notificationId) => {
      const notifDoc = doc(collection(db, "notification_request"));
      await setDoc(notifDoc, {
        createdAt: serverTimestamp(),
        userId,
        notificationId,
        requestId: notifDoc.id,
        meta_data: metaData || [],
      });

      if (isEmailId(notificationId)) {
        const emailDoc = doc(collection(db, "email_requests"));
        await setDoc(emailDoc, {
          createdAt: serverTimestamp(),
          to: userId,
          template_id: notificationId,
          meta_data: metaData || [],
        });
      }
    })
  );
};

export { sendNotificationRequest, sendNotificationRequests };
